import { render, staticRenderFns } from "./PrimaryBtn.vue?vue&type=template&id=21b0bea4&"
import script from "./PrimaryBtn.vue?vue&type=script&lang=js&"
export * from "./PrimaryBtn.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryBtn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBadge,VBtn})
